import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EEAOutputProjectStep1n2ScenarioApiService {

  constructor(private http: HttpClient) { }

  getScenarioDataUseInCalculation( pProjectPk:number): Observable<any[]> {
    const query = `${environment.BAMS_Api_URL}api/getScenarioDataUseInCalculation/${pProjectPk}`;
    return this.http.get(query).pipe(map((data: any) => data));
  }
}